module.exports = __webpack_public_path__ + "static/media/fasaddoor2.8ad0893c.jpeg";